var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.type !== "dbtr"
        ? _c(
            "form-accordion",
            {
              attrs: { title: "Transaction Details", isTitleUpperCase: false },
            },
            [
              _c(
                "b-row",
                { staticClass: "ml-5 mt-4 mb-4 mr-5 mr-5 form-group" },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("label", [_vm._v("Instant Credit Transfer")]),
                      _vm._v(" "),
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: { checked: true },
                          model: {
                            value: _vm.changePassword,
                            callback: function ($$v) {
                              _vm.changePassword = $$v
                            },
                            expression: "changePassword",
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "normal" } },
                            [_vm._v("Instant (SCT Inst)")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: "Amount (€)",
                          value: 85.4,
                          isMandatory: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "ml-5 mt-4 mb-4 mr-5 mr-5 form-group" },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: "Requested Execution Date",
                          value: "2025-10-11",
                          isMandatory: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: "Remittance Information",
                          value: "Invoice #2025-0045 / Contract 987654",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "ml-5 mt-4 mb-4 mr-5 mr-5 form-group" },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: "End-to-End Reference",
                          value: "EndToEndid00000000018",
                          isMandatory: "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type !== "dbtr"
        ? _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("mandate.dbtr_info"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "ml-5 mt-4 mb-4 mr-5 mr-5 form-group" },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("mandate.dbtr_name"),
                          value: _vm.dbtr_name,
                          isMandatory: "",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "5" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          inputLabel: _vm.$t("mandate.dbtr_iban"),
                          value: _vm.dbtr_iban,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type !== "dbtr"
        ? _c(
            "b-row",
            { staticClass: "form-group justify-content-end" },
            [
              _c(
                "b-col",
                { attrs: { sm: "2" } },
                [
                  _c("b-button", { attrs: { variant: "primary" } }, [
                    _c("i", {
                      staticClass: "fa-light fa-paper-plane",
                      attrs: { size: "17px" },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$t("mandate.send")))]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "dbtr"
        ? _c(
            "b-row",
            { staticClass: "form-group justify-content-end" },
            [
              _c(
                "b-col",
                { attrs: { lg: "2", "offset-lg": "8" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "lg" },
                      on: { click: _vm.editProfile },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("mandate.accept")))])]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { sm: "2" } },
                [
                  _c("b-button", { attrs: { variant: "primary" } }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("mandate.refus")))]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }